'use strict';
import PinchZoom from "pinch-zoom-js";
import Siema from 'siema';
import ThumbsSlider from "../thumbs-slider/thumbs-slider";

export default class ProductItemSlider {
	constructor() {
		this.slider = document.querySelector('.js-product-slider');
		if (!this.slider) return false;
		this.mqlMobile = window.matchMedia("(max-width: 767px)");
		this.mqlMobile.addListener(this._onMqlChange.bind(this));
		this.pinchZoomImages = [];
		this.zoomModalOpened = false;
		this.pinchZoomInited = false;
		this.productSlider = null;
		this.zoomSlider = null;
		this._matchHTML();
		this._initSlider();
		this._initThumbs();
		if (!this.mqlMobile.matches) {
			setTimeout(() => this._initZoom(), 5000);
		}
		this._zoomModal();
		window.zoom = PinchZoom;
		window.Siema = Siema;
	}

	_matchHTML() {
		this.thumbs = document.querySelector('[data-main-thumbs]');
		this.zoomModal = document.querySelector('[data-zoom-modal]');
		this.zoomSlider = document.querySelector('.js-zoom-slider');
		this.videos = this.zoomModal.querySelectorAll('[data-video]');
		this.zoomThumbs = this.zoomModal.querySelector('[data-zoom-thumbs]');
		this.zoomThumbsMobile = this.zoomModal.querySelector("[data-zoom-thumbs-mobile]");
		this.zoomContainer = document.querySelector("#zoom-container");
		this.container = document.querySelector(".product-item-slider");
	}

	_onMqlChange() {
		if (!this.mqlMobile.matches) {
			this._initZoom();
			this._destroyPinchZoom();
		} else if (this.mqlMobile.matches && this.zoomModalOpened) {
			this._initPinchZoom();
		} else if (this.mqlMobile.matches) {
			this._destroyZoom();
		}
	}

	_onZoomImageClick(e) {
		if (e.target.classList.contains("tracker")) {
			$("#zoomSlider").modal()
		}
	}

	_updatePinchZoom() {
		if (!this.zoomModalOpened || !this.pinchZoomInited) return;
		if (this.mqlMobile.matches && this.pinchZoomInited) {
			this.pinchZoomImages.forEach((image) => {
				image.setupOffsets();
				image.update();
			})
		}
	}

	_initPinchZoom() {
		if (this.pinchZoomInited) return;
		const images = document.querySelectorAll("[data-pinch-zoom]");
		images.forEach((image) => {
			this.pinchZoomImages.push(new PinchZoom(image, {
				draggableUnzoomed: false
			}));
		})
		this.pinchZoomInited = true;
	}

	_destroyPinchZoom() {
		if (!this.pinchZoomInited) return;
		this.pinchZoomImages.forEach((image) => {
			const clonedImg = image.el.cloneNode();
			clonedImg.style = "";
			const container = image.container.parentElement;
			image.container.remove();
			image.el.remove();
			image = null;
			container.append(clonedImg);
		})
		this.pinchZoomImages = [];
		this.pinchZoomInited = false;
	}

	_initZoom() {
		let that = this;
		this.zoomImages = this.slider.querySelectorAll("[data-zoom-img]");
		this.zoomImages.forEach((img) => {
			if (img.complete && img.naturalHeight !== 0) {
				that._initZoomImage(img);
			} else {
				$(img).on("load", function() {
					that._initZoomImage(this);
				});
			}
		});
		document.addEventListener("click", this._onZoomImageClick.bind(this));
	}

	_initZoomImage(img) {
		$(img).imagezoomsl({
			descarea: "#zoom-container",
			zoomrange: [1, 12],
			magnifiereffectanimate: "fadeIn",
			magnifierborder: "none",
		});
	}

	_destroyZoom() {
		this.zoomImages.forEach((img) => {
			const imgClone = img.cloneNode(true);
			img.parentNode.replaceChild(imgClone, img);
		});

		//удаляем все элементы, которые создала библиотека
		const selectors = [".magnifier", ".cursorshade", ".statusdiv", ".tracker"];
		this._removeAllElements(selectors);

		document.removeEventListener("click", this._onZoomImageClick.bind(this));
	}

	_removeAllElements(selectors) {
		selectors.forEach((selector) => {
			const toRemove = document.querySelectorAll(selector);
			if (toRemove.length) {
				toRemove.forEach((el) => el.remove());
			}
		});
	}

	_initSlider() {
		if (!this.slider || !this.thumbs || !this.zoomSlider) return false;
		 
		this.productSlider = new Siema({
			selector: this.slider,
			onInit: () => {
				this.slider.classList.add("is-inited");
			},
			onChange: () => {
				this.slider.classList.add("is-changing");
				this.thumbsSlider.goTo(this.productSlider.currentSlide, false);
				this.zoomSlider.goTo(this.productSlider.currentSlide);
				setTimeout(() => this.slider.classList.remove("is-changing"), this.productSlider.config.duration)
			}
		});

		this.zoomSlider = new Siema({
			selector: this.zoomSlider,
			onChange: () => {
				if (this.thumbsSliderZoom && this.productSlider) {
					this.thumbsSliderZoom.goTo(this.zoomSlider.currentSlide, false);
					this.productSlider.goTo(this.zoomSlider.currentSlide);
				}
				[...this.zoomThumbsMobile.querySelectorAll(".zoom-thumbs__thumb-wrapper")].forEach((thumb, index) => {
					if (index == this.zoomSlider.currentSlide) {
						thumb.classList.remove("is-hidden");
					} else {
						thumb.classList.add("is-hidden");
					}
				});
			}
		});

		let zoomPrev = document.querySelector(".zoom-slider__arrow--prev");
		let zoomNext = document.querySelector(".zoom-slider__arrow--next");
		zoomPrev.addEventListener("click", () => this.zoomSlider.prev());
		zoomNext.addEventListener("click", () => this.zoomSlider.next());

		this.zoomSlider.config.onChange();
	}

	_initThumbs() {
		this.thumbsSlider = new ThumbsSlider(this.thumbs, this.productSlider);
		this.thumbsSliderZoom = new ThumbsSlider(this.zoomThumbs, this.zoomSlider);
	}

	_zoomModal() {
		let that = this;

		$(this.zoomModal).on('modal:open', function(event, modal) {
			modal.$blocker[0].classList.add("blocker--gallery");

			that.zoomSlider.resizeHandler();

			that.videos.forEach(video => {
				if (!video.classList.contains('is-inited')){
					let id = video.dataset.video;

					video.appendChild(that._getIframe(id));

					video.classList.add('is-inited');
				}
			})

			if (!that.pinchZoomInited && that.mqlMobile.matches) that._initPinchZoom();
			that.zoomModalOpened = true;
		});

		$(this.zoomModal).on('modal:close', function(event, modal) {
			that.videos.forEach(video => {
				if (video.classList.contains('is-inited')){
					video.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
				}
			})

			// that._destroyPinchZoom();

			that.zoomModalOpened = false;
		})

		$(this.zoomSlider).on("setPosition", this._updatePinchZoom.bind(this));

		$(this.zoomSlider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			that.videos.forEach(video => {
				if (video.classList.contains('is-inited')){
					video.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
				}
			})
		})
	}

	_getIframe(videoId) {
		let iframe = document.createElement('iframe'),
			isMidDesktop = false,

			width = (isMidDesktop) ? window.innerWidth * .55 : window.innerWidth,
			height = (isMidDesktop) ? Math.min(width * .625, window.innerHeight * .9) : window.innerHeight;

		iframe.onload = function() {
			if (window.modalContentIsReady) window.modalContentIsReady();
		};

		[
			{attribute: 'src',				   value: `https://www.youtube.com/embed/${videoId}?rel=0&enablejsapi=1&version=3`},
			{attribute: 'width',				 value: width},
			{attribute: 'height',				value: height},
			{attribute: 'frameborder',		   value: 0},
			{attribute: 'vspace',				value: 0},
			{attribute: 'hspace',				value: 0},
			{attribute: 'webkitallowfullscreen', value: true},
			{attribute: 'mozallowfullscreen',	value: true},
			{attribute: 'allowfullscreen',	   value: true},
			{attribute: 'scrolling',			 value: 'no'},
			{attribute: 'allow',				 value: 'autoplay; encrypted-media'}
		].forEach(param => {
			iframe.setAttribute(param.attribute, param.value);
		});

		iframe.style.setProperty('display', 'block');

		this.iframe = iframe;

		// window.addEventListener('resize', help.debounce(e => {
		// 	let isMidDesktop = window.matchMedia(media.min.midDesktop).matches,
		// 		width = (isMidDesktop) ? Math.floor(window.innerWidth / 2) : window.innerWidth,
		// 		height = (isMidDesktop) ? Math.min(width * .625, window.innerHeight * .9) : window.innerHeight;

		// 	iframe.setAttribute('width', width);
		// 	iframe.setAttribute('height', height);
		// }, 250));

		return iframe;

	}
}
